import styled from 'styled-components';
import { SPACING_3 } from '../../theme';

export const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_3};
`;
